<template>
  <div
    class="popover"
    @click="goToHomePage"
  >
    <img
      alt="Thunderstock logo"
      class="thunder-logo"
      :src="thunderstockLogo"
      :width="width"
    >
  </div>
</template>

<script>
import thunderstockLogo from '@/assets/img/aot-icon.svg'

export default {
  name: 'Logo',
  props: {
    activeModule: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: '30px',
    },
    to: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      thunderstockLogo: thunderstockLogo,
    }
  },
  methods: {
    goToHomePage () {
      if (this.to) {
        this.$router.push({ path: this.to })
        return
      }
      const routes = {
        buy: 'buy-home-page',
        stock: 'stock-home-page',
        pricing: 'pricing-home-page',
        strategy: 'strategy-home-page',
      }
      const generalPage = this.$route.name.split('-')[0]
      if (generalPage === 'storepage') {
        this.$router.push({ name: 'stock-transfers' })
        return
      }
      this.$router.push({ name: routes[generalPage] })
    },
  }
}
</script>

<style lang="scss">

.popover {
  cursor: pointer;
}
.thunder-logo {
  margin-top: 6px !important;
  // Centres the 30px icon above the 70px sidebar rail's icons.
  margin-left: 3px;
}
</style>
